
import React, { useState } from 'react';
import { Eye, EyeSlash } from 'iconsax-react';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { List, ListItem, ListItemText } from '@mui/material';

const PasswordField = ({ formik, label, id, required, validate }) => {
    const [showPassword, setShowPassowrd] = useState(false);
    const [suggestions, setSuggestions] = useState({
        length: { text: 'Should be at least 8 characters.', valid: false },
        includeNumbers: { text: 'Includes one number (1, 2, 3...)', valid: false },
        includeUpperCase: { text: 'Includes one uppercase letter (A, B, C...)', valid: false },
        includeLowerCase: { text: 'Includes one lowercase letter (a, b, c...)', valid: false },
        includeSymbol: { text: 'Includes one special character (!, @, $...)', valid: false },
    });

    const validatePassword = (password) => {
        const newSuggestions = { ...suggestions };
        const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

        if (password.length > 8)
            newSuggestions.length.valid = true;
        else
            newSuggestions.length.valid = false;

        if (/\d+/g.test(password))
            newSuggestions.includeNumbers.valid = true;
        else
            newSuggestions.includeNumbers.valid = false;

        if (/[a-z]+/g.test(password))
            newSuggestions.includeLowerCase.valid = true;
        else
            newSuggestions.includeLowerCase.valid = false;

        if (/[A-Z]+/g.test(password))
            newSuggestions.includeUpperCase.valid = true;
        else
            newSuggestions.includeUpperCase.valid = false;

        if (specialChars.test(password))
            newSuggestions.includeSymbol.valid = true;
        else
            newSuggestions.includeSymbol.valid = false;

        setSuggestions(newSuggestions);
    };


    return (
        <>
            <FormControl variant="outlined">
                <InputLabel
                    error={formik.touched[id] && Boolean(formik.errors[id])}
                    required={required}
                    htmlFor={id}
                >
                    {label}
                </InputLabel>
                <OutlinedInput
                    required={required}
                    id={id}
                    type={showPassword ? 'text' : 'password'}
                    value={formik.values[id]}
                    onChange={(e) => { validatePassword(formik.values[id]); formik.handleChange(e) }}
                    onBlur={(e) => { validatePassword(formik.values[id]); formik.handleBlur(e) }}
                    error={formik.touched[id] && Boolean(formik.errors[id])}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassowrd(!showPassword)}
                                edge="end"
                            >
                                {showPassword ?
                                    <EyeSlash
                                        size="24"
                                        variant="Bulk"
                                    />
                                    :
                                    <Eye
                                        size="24"
                                        variant="Bulk"
                                    />
                                }
                            </IconButton>
                        </InputAdornment>
                    }
                    label={label}
                />
                <FormHelperText error={formik.touched[id] && Boolean(formik.errors[id])}>
                    {formik.touched[id] && formik.errors[id]}
                </FormHelperText>

                <List dense>
                    {validate && Object.values(suggestions).map((item) => !item.valid && (
                        <ListItem key={item.text}>
                            <ListItemText
                                primaryTypographyProps={{ fontSize: '12px' }}
                                primary={'* ' + item.text}
                            />
                        </ListItem>
                    ))}
                </List>

            </FormControl>
        </>
    );
}

export default PasswordField;